import { OMNI_STRINGS, OmniViewMode } from '../omnidashboard.config';
import {
  LegendEntry,
  MatrixCellData,
  MetricData,
  OmniMetricDefinition,
} from '../omnidashboard.models';
import { ACKNOWLEDGEMENT_STATUS_METRIC } from './acknowledgement-status.metric';
import { ACKNOWLEDGEMENT_STATUS_LOADER } from './acknowledgement-status.loader';
import { ANNUAL_PLAN_STATUS_METRIC } from './annual-plan-status.metric';
import { ANNUAL_PLAN_STATUS_LOADER } from './annual-plan-status.loader';
import { CHAPTER_STATUS_METRIC } from './chapter-status.metric';
import { OmniMetricLoader } from './metric-loader';

export const OMNI_METRIC_DEFINITIONS: OmniMetricDefinition[] = [
  CHAPTER_STATUS_METRIC,
  ACKNOWLEDGEMENT_STATUS_METRIC,
  ANNUAL_PLAN_STATUS_METRIC,
];

export const OMNI_METRIC_DEFINITION_BY_KEY = new Map<OmniViewMode, OmniMetricDefinition>(
  OMNI_METRIC_DEFINITIONS.map((metric) => [metric.key, metric])
);

export const OMNI_VIEWS: { key: OmniViewMode; label: string }[] =
  OMNI_METRIC_DEFINITIONS.map((metric) => ({ key: metric.key, label: metric.label }));

export const DEFAULT_OMNI_VIEW: OmniViewMode = 'chapter-status';

const OMNI_VIEW_KEYS = new Set<OmniViewMode>(OMNI_VIEWS.map((view) => view.key));

export function isOmniViewMode(view: string | null): view is OmniViewMode {
  return typeof view === 'string' && OMNI_VIEW_KEYS.has(view as OmniViewMode);
}

export function getLegendForView(view: OmniViewMode): LegendEntry[] {
  const definition = OMNI_METRIC_DEFINITION_BY_KEY.get(view);
  return definition ? definition.legend : [];
}

export function buildDefaultMetricMap(definitions: OmniMetricDefinition[]): Map<string, MetricData> {
  return new Map<string, MetricData>(definitions.map((definition) => [definition.key, definition.naMetric]));
}

export function getMetricDefinitionOrThrow(view: OmniViewMode): OmniMetricDefinition {
  const definition = OMNI_METRIC_DEFINITION_BY_KEY.get(view);
  if (!definition) {
    return OMNI_METRIC_DEFINITION_BY_KEY.get(DEFAULT_OMNI_VIEW) || CHAPTER_STATUS_METRIC;
  }
  return definition;
}

export function formatDefaultCellTooltip(cell: MatrixCellData): string {
  return cell.siteName + ' – ' + cell.bpgName + ' · ' + OMNI_STRINGS.cellOpenTooltip;
}

/** API-backed metrics register a loader here; chapter-status is seeded during matrix build. */
export const OMNI_METRIC_LOADERS: OmniMetricLoader[] = [
  ACKNOWLEDGEMENT_STATUS_LOADER,
  ANNUAL_PLAN_STATUS_LOADER,
];

const OMNI_METRIC_LOADER_BY_KEY = new Map<OmniViewMode, OmniMetricLoader>(
  OMNI_METRIC_LOADERS.map((loader) => [loader.key, loader])
);

export function getMetricLoader(view: OmniViewMode): OmniMetricLoader | undefined {
  return OMNI_METRIC_LOADER_BY_KEY.get(view);
}
